import * as React from 'react';
import { getLCP, getFID, getCLS, getFCP, getTTFB, Metric } from 'web-vitals/base';
import { useSelector } from 'react-redux';
import { getEdition } from '../../store/config/config.selectors';

const sendToGoogleAnalytics = ({ name, delta, id }: Metric) => {
  window.mmClientApi = window.mmClientApi || [];
  window.mmClientApi.push('analytics', {
    event_category: 'Web Vitals',
    event_action: name,
    event_label: id,
    event_value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    non_interaction: true,
    transport: 'beacon',
  });
};

const PROPERTY_MENTAL_FLOSS = 'mentalfloss';
const PROPERTY_90MIN_EN = '90min_en_international_web';
const PROPERTY_TPT_EN = 'theplayertribune';
const PROPERTY_BOLTBEAT = '13';

export const CoreWebVitals: React.FunctionComponent = () => {
  const property = useSelector(getEdition);
  React.useEffect(() => {
    try {
      if (property === PROPERTY_MENTAL_FLOSS || property === PROPERTY_90MIN_EN || property === PROPERTY_TPT_EN || property === PROPERTY_BOLTBEAT) {
        getCLS(sendToGoogleAnalytics);
        getFID(sendToGoogleAnalytics);
        getLCP(sendToGoogleAnalytics);
        getFCP(sendToGoogleAnalytics);
        getTTFB(sendToGoogleAnalytics);
      }
    } catch (e) {
      console.error('CoreWebVitals', e);
    }
  }, [property]);
  return null;
};
